import { useQuery } from "@tanstack/react-query";
import {
  getJointBillServicesExpectedPaymentAmount,
  getPaymentTaxCollectorTypes,
} from "./services";
import {
  type IGetJointBillServicesExpectedPaymentAmountRequestParams,
  type IPaymentTaxCollectorTypes,
} from "./types";

export const usePaymentTaxCollectorTypes = () =>
  useQuery<IPaymentTaxCollectorTypes>({
    queryKey: ["payment", "taxCollectorTypes"],
    queryFn: getPaymentTaxCollectorTypes,
  });

export const useGetJointBillServicesExpectedPaymentAmount = (
  data: IGetJointBillServicesExpectedPaymentAmountRequestParams,
) => {
  return useQuery({
    queryKey: [
      "jointBillServicesExpectedPaymentAmount",
      data.periodId,
      data.selectedJointBillServiceIds.join(","),
    ],
    queryFn: () => getJointBillServicesExpectedPaymentAmount(data),
    enabled: !!data.selectedJointBillServiceIds.length,
  });
};
